import { useFormikContext } from 'formik';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import * as Core from 'components/core';
import { RadioGroup } from './RadioGroup';
import { RadioInput } from './RadioInput';
import { Values } from './types';

interface Props {}

const LicenseeInformation: FC<Props> = () => {
  const { t } = useTranslation(['translation', 'checkout']);
  const { values, setFieldValue, handleChange, handleBlur } =
    useFormikContext<Values>();

  return (
    <>
      <RadioGroup aria-label="Entity Type">
        <RadioInput
          label={t('payment.licensee.legalEntity', { ns: 'checkout' })}
          hint={t('payment.licensee.legalEntityHint', { ns: 'checkout' })}
          name="licenseeIsLegalEntity"
          value="true"
          checked={values.licenseeIsLegalEntity === true}
          required
          onChange={(event) => {
            if (event.currentTarget.checked) {
              setFieldValue('licenseeIsLegalEntity', true);
            }
          }}
          onBlur={handleBlur}
        />

        <RadioInput
          label={t('payment.licensee.naturalPerson', { ns: 'checkout' })}
          hint={t('payment.licensee.naturalPersonHint', { ns: 'checkout' })}
          name="licenseeIsLegalEntity"
          value="false"
          checked={values.licenseeIsLegalEntity === false}
          required
          onChange={(event) => {
            if (event.currentTarget.checked) {
              setFieldValue('licenseeIsLegalEntity', false);
            }
          }}
          onBlur={handleBlur}
        />
      </RadioGroup>

      <Core.InputFormGroup
        name="licenseeEmail"
        type="email"
        value={values.licenseeEmail}
        label={t('payment.licensee.email', { ns: 'checkout' })}
        testID="licensee-email-field"
        required
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="licenseeName"
        value={values.licenseeName}
        label={t('payment.licensee.name', { ns: 'checkout' })}
        testID="licensee-name-field"
        required
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <p>{t('payment.licensee.description', { ns: 'checkout' })}</p>
    </>
  );
};

export default LicenseeInformation;
